<template>
  <v-container fluid>
    <div class="forbidden-words-actions">
      <v-btn color="primary" @click="addForbiddenWord">
        금지어 추가
      </v-btn>
      <v-btn color="error" @click="removeSelected" :disabled="selected.length === 0">
        선택 삭제
      </v-btn>
    </div>

    <v-data-table
      v-model="selected"
      :headers="forbiddenWordsHeaders"
      :items="forbiddenWordsList"
      item-value="id"
      return-object
      show-select
      class="mt-3"
      hide-default-footer
      items-per-page="-1"
    >
      <template v-slot:[`item.before`]="{ item }">
        <v-text-field v-model="item.before" hide-details variant="underlined" density="compact" />
      </template>
      <template v-slot:[`item.after`]="{ item }">
        <v-text-field v-model="item.after" hide-details variant="underlined" density="compact" />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { VDataTable } from 'vuetify/components';

export default {
  components: {
    VDataTable,
  },
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      forbiddenWordsList: [],
      selected: [],
      idCounter: 1,
      forbiddenWordsHeaders: [
        { title: '', key: 'data-table-select', sortable: false, width: '56px' },
        { title: '변환 전 금지어', key: 'before' },
        { title: '변환 후 단어', key: 'after' },
      ],
    };
  },
  watch: {
    modelValue: {
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.forbiddenWordsList)) {
          this.initializeForbiddenWordsList();
        }
      },
      immediate: true,
      deep: true,
    },
    forbiddenWordsList: {
      handler(newVal) {
        if (JSON.stringify(newVal) === JSON.stringify(this.modelValue || [])) {
          return;
        }
        this.$emit('update:modelValue', newVal.map((item) => ({ ...item })));
      },
      deep: true,
    },
  },
  methods: {
    initializeForbiddenWordsList() {
      this.forbiddenWordsList = (this.modelValue || []).map((item) => ({ ...item }));
      if (this.forbiddenWordsList.length > 0) {
        const ids = this.forbiddenWordsList.map((word) => word.id);
        this.idCounter = Math.max(...ids) + 1;
      } else {
        this.idCounter = 1;
      }
      this.selected = [];
    },
    addForbiddenWord() {
      this.forbiddenWordsList.push({ id: this.idCounter, before: '', after: '' });
      this.idCounter += 1;
    },
    removeSelected() {
      const idsToRemove = this.selected.map((item) => item.id);
      this.forbiddenWordsList = this.forbiddenWordsList.filter(
        (word) => !idsToRemove.includes(word.id)
      );
      this.selected = [];
    },
  },
};
</script>

<style scoped>
.forbidden-words-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
</style>

